import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../../assets/bottom-logo.png";
import { getCurrentLanguage } from "@/store/data/global";
import { EnvironmentOutlined, MailOutlined } from "@ant-design/icons";
import "./index.less";

const BottomPage = () => {
  const location = useLocation();
  const currentLanguage = useSelector(getCurrentLanguage);
  const footerRef = useRef(null);

  // 保留你原来的 #footer 跳转逻辑（兼容旧链接）
  useEffect(() => {
    const handleHashChange = () => {
      if (window.location.hash === "#footer") {
        setTimeout(() => {
          scrollToFooter();
        }, 100);
      }
    };

    if (window.location.hash === "#footer") {
      handleHashChange();
    }

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const scrollToFooter = () => {
    const footerElement = document.getElementById("footer");
    if (footerElement) {
      footerElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    window.scrollToFooter = scrollToFooter;
    return () => delete window.scrollToFooter;
  }, []);

  // 关键：新的导航配置，使用 #hash 锚点跳转
  const navItems = [
    {
      path: "/products",
      key: "products",
      name: { EN: "Products", ES: "Productos" },
      Children: [
        {
          key: "gpu",
          name: { EN: "GPU & Core Components", ES: "GPU y Componentes Centrales" },
          hash: "#gpu",
        },
        {
          key: "storage",
          name: { EN: "Storage Components & RAID Cards", ES: "Componentes de Almacenamiento y Tarjetas de Arreglo" },
          hash: "#storage",
        },
        {
          key: "power",
          name: { EN: "Power Supplies & Power Systems", ES: "Sistemas de Energía y Alimentación" },
          hash: "#power",
        },
        {
          key: "cooling",
          name: { EN: "Cooling & Supporting Components", ES: "Refrigeración y Componentes de Soporte" },
          hash: "#cooling",
        },
      ],
    },
    {
      path: "/clients",
      key: "clients",
      name: { EN: "Clients & Business Scenarios", ES: "Clientes y Escenarios de Negocio" },
      Children: [
        { key: "media", name: { EN: "Media & Entertainment", ES: "Medios y Entretenimiento" }, hash: "#media" },
        { key: "fintech", name: { EN: "Fintech & Services", ES: "Tecnología Financiera y Servicios" }, hash: "#fintech" },
        { key: "healthcare", name: { EN: "Healthcare & Life Sciences", ES: "Medicina y Ciencias de la Vida" }, hash: "#healthcare" },
        { key: "energy", name: { EN: "Energy & Industry", ES: "Energía e Industria" }, hash: "#energy" },
      ],
    },
    {
      path: "/about",
      key: "about",
      name: { EN: "About Us", ES: "Nosotros" },
      Children: [
        { key: "why", name: { EN: "Why Choose Us", ES: "¿Por Qué Elegirnos?" }, hash: "#why" },
        { key: "contact", name: { EN: "Contact Us", ES: "Contáctenos" }, hash: "#contact" },
      ],
    },
    {
      path: "/services",
      key: "services",
      name: { EN: "Services & Cooperation", ES: "Servicio y Colaboración" },
      Children: [
        { key: "guarantee", name: { EN: "Service Guarantee", ES: "Garantías de Servicio" }, hash: "#guarantee" },
        { key: "cooperation", name: { EN: "Cooperation Process", ES: "Proceso de Colaboración" }, hash: "#cooperation" },
      ],
    },
  ];

  const isActiveLink = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const addressText = {
    EN: "Laguna de Mayran 166, Anáhuac I Secc, Miguel Hidalgo, 11320 Ciudad de México, CDMX",
    ES: "Laguna de Mayran 166, Anáhuac I Secc, Miguel Hidalgo, 11320 Ciudad de México, CDMX",
  };
  const emailText = { EN: "", ES: "" };

  return (
    <footer className="global-footer" id="footer" ref={footerRef}>
      <div className="themesCube middle">
        <div className="anchor-cube flex">
          {navItems.map((item) => (
            <dl key={item.key} className="item-in">
              <dt>{item.name[currentLanguage]}</dt>
              {item.Children &&
                item.Children.map((child) => (
                  <dd key={child.key}>
                    <Link
                      to={`${item.path}${child.hash}`}  // 关键：跳转到 /products#gpu
                      className={
                        location.pathname === item.path && location.hash === child.hash
                          ? "active"
                          : ""
                      }
                    >
                      {child.name[currentLanguage]}
                    </Link>
                  </dd>
                ))}
            </dl>
          ))}
        </div>

        <div className="information flex">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="Company Logo" />
            </Link>
          </div>
          <div className="intro-item">
            <div className="intro">
              <div className="name flex">
                <p>{currentLanguage === "EN" ? "Email" : "EI Correo electrónico"}</p>
                <MailOutlined />
              </div>
              <div className="line">{emailText[currentLanguage]}</div>
            </div>
            <div className="intro">
              <div className="name flex">
                <p>{currentLanguage === "EN" ? "Address" : "La dirección"}</p>
                <EnvironmentOutlined />
              </div>
              <div className="line">{addressText[currentLanguage]}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BottomPage;